import React from "react";
import {
  DotsThreeVertical,
} from "@phosphor-icons/react";


export default function DocumentsMobileList({
  items,
  selectedDocIds,
  selectedFolderIds,
  onToggleDocument,
  onToggleFolder,
  onOpenFolder,
  onPreviewDocument,
  onOpenActions,
}) {
  return (
    <div
      className="documents-v2-mobile-list"
      data-testid="documents-mobile-list"
    >
      {items.map((item) => {
        const isFolder =
          item.itemType === "folder";

        const selected =
          isFolder
            ? selectedFolderIds.has(item.id)
            : selectedDocIds.has(item.id);

        return (
          <article
            key={`${item.itemType}-${item.id}`}
            className={`documents-v2-mobile-list-item ${
              selected
                ? "is-selected"
                : ""
            }`}
            data-testid={`mobile-list-${item.itemType}-${item.id}`}
          >
            <div className="documents-v2-mobile-list-select">
              <input
                type="checkbox"
                checked={selected}
                onChange={() => {
                  if (isFolder) {
                    onToggleFolder(item.id);
                  } else {
                    onToggleDocument(item.id);
                  }
                }}
                aria-label={`Sélectionner ${item.name}`}
                data-testid={`mobile-select-${item.itemType}-${item.id}`}
              />
            </div>

            <button
              type="button"
              className="documents-v2-mobile-list-main"
              onClick={() => {
                if (isFolder) {
                  onOpenFolder(item.id);
                } else {
                  onPreviewDocument(item);
                }
              }}
              data-testid={`mobile-open-${item.itemType}-${item.id}`}
            >
              <span className="documents-v2-mobile-list-name">
                {item.name}
              </span>
            </button>

            <button
              type="button"
              className="documents-v2-mobile-list-actions"
              onClick={() =>
                onOpenActions(item)
              }
              aria-label={`Actions pour ${item.name}`}
              data-testid={`mobile-list-actions-${item.itemType}-${item.id}`}
            >
              <DotsThreeVertical
                size={19}
                weight="bold"
              />
            </button>
          </article>
        );
      })}
    </div>
  );
}
